module.exports = __webpack_public_path__ + "img/role_sad.a67dee8c.png";